export default "__VITE_ASSET__Bcc4CG1C__"